import { useState } from "react";
import { Link } from "react-router-dom";
import { Zap, Menu, X } from "lucide-react";

const LINKS = [
  { href: "#services", label: "Services", testid: "nav-services-link" },
  { href: "#gallery", label: "Before / After", testid: "nav-gallery-link" },
  { href: "#manifesto", label: "Manifesto", testid: "nav-manifesto-link" },
  { href: "#booking", label: "Book Now", testid: "nav-booking-link" },
];

export const Header = () => {
  const [open, setOpen] = useState(false);
  return (
    <header data-testid="site-header" className="fixed top-0 left-0 right-0 z-50 backdrop-blur-xl bg-slate-950/80 border-b border-amber-500/15">
      <div className="px-4 sm:px-8 lg:px-12 max-w-7xl mx-auto h-16 flex items-center justify-between">
        <a href="#top" data-testid="nav-logo" className="flex items-center gap-2 group">
          <span className="w-8 h-8 bg-amber-500 flex items-center justify-center">
            <Zap className="w-5 h-5 text-slate-950" strokeWidth={2.5} />
          </span>
          <span className="font-condensed font-extrabold uppercase tracking-wide text-lg text-slate-100">
            Fix <span className="text-amber-500">&amp;</span> Finish
          </span>
        </a>
        <nav className="hidden md:flex items-center gap-8">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={l.testid}
               className="text-sm font-medium text-slate-400 hover:text-amber-400 transition-colors duration-300">
              {l.label}
            </a>
          ))}
          <Link to="/admin/login" data-testid="nav-admin-link"
                className="text-sm font-medium text-slate-500 hover:text-slate-300 transition-colors duration-300">
            Owner Login
          </Link>
          <a href="#booking" data-testid="nav-book-cta"
             className="bg-amber-500 hover:bg-amber-600 text-slate-950 font-condensed font-bold uppercase tracking-wide text-sm px-5 py-2 transition-all duration-300 hover:-translate-y-0.5 hover:shadow-[0_8px_20px_rgba(245,158,11,0.35)]">
            Book Job Now
          </a>
        </nav>
        <button className="md:hidden text-slate-200" data-testid="nav-mobile-toggle" onClick={() => setOpen(!open)} aria-label="Toggle menu">
          {open ? <X className="w-6 h-6" /> : <Menu className="w-6 h-6" />}
        </button>
      </div>
      {open && (
        <nav className="md:hidden border-t border-amber-500/15 bg-slate-950/95 px-4 py-4 flex flex-col gap-4">
          {LINKS.map((l) => (
            <a key={l.href} href={l.href} data-testid={`mobile-${l.testid}`} onClick={() => setOpen(false)}
               className="text-base font-medium text-slate-300 hover:text-amber-400">
              {l.label}
            </a>
          ))}
          <Link to="/admin/login" data-testid="mobile-nav-admin-link" onClick={() => setOpen(false)}
                className="text-base font-medium text-slate-500">
            Owner Login
          </Link>
        </nav>
      )}
    </header>
  );
};
